module.exports = __webpack_public_path__ + "img/softinya-8.49260e45.png";